/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

/**
 * @description Successfully fetched the list of follow requests you have
 */
export const getReceivedFollowRequests200Schema = z.object({
  requests: z.array(
    z.object({
      requestId: z.string(),
      followerId: z.string(),
      followerUsername: z.string(),
      createdAt: z.string().datetime(),
    }),
  ),
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const getReceivedFollowRequests401Schema = APIErrorSchema

export const getReceivedFollowRequestsQueryResponseSchema =
  getReceivedFollowRequests200Schema
